const t = {
  name: "Payout",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 6H22V18H3V20H24V4H0V6Z" fill="currentColor"/>
<path d="M8 12C8 9.79772 9.79772 8 12 8C14.2023 8 16 9.79772 16 12C16 14.2023 14.2023 16 12 16C9.79772 16 8 14.2023 8 12ZM12 10C10.9023 10 10 10.9023 10 12C10 13.0977 10.9023 14 12 14C13.0977 14 14 13.0977 14 12C14 10.9023 13.0977 10 12 10Z" fill="currentColor"/>
<path d="M17 11.2H20V13.2H17V11.2Z" fill="currentColor"/>
<path d="M6 9H1V11H6V9Z" fill="currentColor"/>
<path d="M2 13H7V15H2V13Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Payout
};
